import React from "react";

export default function DeviceBattery({ battery = null }) {
  const batteryFormatted = battery !== null ? `${battery}%` : "-";

  return <span>{batteryFormatted}</span>;
}
